import React from 'react';
import { useTranslation } from 'react-i18next';
import ChartCardContainer from './ChartCardContainer';
import CommodityChart from './CommodityChart';
import CommodityNeedProjection from './CommodityNeedProjection';

const AvailabilityAndNeed = ({ materialCode }) => {
  const { t } = useTranslation();
  return (
    <ChartCardContainer title={t("charts.section.availabilityNeed")}>
      <div className="availability-need-layout">
        {/* Left section - Commodity Availability */}
        <div className="availability-section">
          <CommodityChart materialCode={materialCode} />
        </div>

        {/* Right section - Commodity Need Projection */}
        <div className="need-section">
          <CommodityNeedProjection materialCode={materialCode} />
        </div>
      </div>
    </ChartCardContainer>
  );
};

export default AvailabilityAndNeed;
